import React from 'react'
import resolveProps from '../../utils/resolveProps'
import Link from '../Link'
import { Props } from './types'
import './index.scss'
//imports elements

const config = {
  types: [
    {
      title: 'default',
      isDefault: true
    },
    'secondary'
  ],
  modifiers: [
    {
      title: 'signature',
      isDefault: true
    },
    'bottom'
  ]
}

export default function Footer(props: Props) {
  const {
    children,
    data = {},
    tag,
    secondary,
    onClickLibras,
    librasProps,
    bottom,
    ...rest
  } = props
  const {
    socialTagLinks = '',
    social = [],
    imageSrc = '',
    imageAlt = ''
  } = data
  const CustomTag = tag || 'footer'
  const CustomSocialTag = socialTagLinks || 'a'

  const isSocial =
    social && Array.isArray(social) && social?.length ? true : false

  return (
    <CustomTag
      {...rest}
      className={`${resolveProps(props, config, 'Footer')} ${
        isSocial ? 'mdn-Footer--social' : 'mdn-Footer--simple'
      } ${bottom ? 'mdn-Footer--signature' : ''}`}
      role="contentinfo"
    >
      <div className="mdn-Container">
        <div className="mdn-Footer-content">
          <div
            className={`mdn-Footer-${isSocial ? 'social-and-' : ''}disclaimer`}
          >
            {isSocial && (
              <ul className="mdn-Footer-list">
                {Array.isArray(social) &&
                  social?.map((item, index) => {
                    const { href = '', icon = '', gtm = {}, ...itemRest } = item

                    const classIcon = item.icon ? `mdn-Icon-${item?.icon}` : ''

                    return (
                      <li
                        key={`social-icon-${index}`}
                        className="mdn-Footer-list-item"
                      >
                        {href ? (
                          <Link
                            tag={CustomSocialTag}
                            href={href}
                            gtm={gtm}
                            {...itemRest}
                          >
                            {!!item?.children ? (
                              item?.children
                            ) : (
                              <span
                                aria-hidden="true"
                                className={`${classIcon} mdn-Icon--md`}
                              />
                            )}
                          </Link>
                        ) : (
                          <>
                            {!!item?.children ? (
                              item?.children
                            ) : (
                              <span
                                {...itemRest}
                                aria-hidden="true"
                                className={`${classIcon} mdn-Icon--md mdn-Text--inverse`}
                              ></span>
                            )}
                          </>
                        )}
                      </li>
                    )
                  })}
              </ul>
            )}
            <div className="mdn-Footer-disclaimer">
              <p className="mdn-Text mdn-Text--caption mdn-Text--inverse">
                {data.privacy?.map((item, index) =>
                  !!item?.children ? (
                    item?.children
                  ) : (
                    <a
                      className="mdn-Footer-disclaimer-link"
                      href={item.href}
                      target={item.target}
                      key={index}
                    >
                      {item.text}
                    </a>
                  )
                )}
                {data.privacy && (onClickLibras || librasProps?.onClickLibras) && (
                  <button
                    className={`mdn-Footer-disclaimer-librasLink ${librasProps?.gtm?.gtmClassName}`}
                    onClick={librasProps?.onClickLibras || onClickLibras}
                    {...librasProps?.buttonProps}
                    {...librasProps?.gtm?.dataGTM}
                  >
                    <i
                      className="mdn-Icon-libras mdn-Icon--sm"
                      style={{
                        color: 'var(--color-neutral-lightest)',
                        cursor: 'pointer'
                      }}
                    ></i>
                  </button>
                )}
              </p>
              <p className="mdn-Text mdn-Text--caption mdn-Text--inverse">
                {typeof children === 'string' ? (
                  <strong>{children}</strong>
                ) : (
                  children
                )}
              </p>
            </div>
          </div>
          <div className={`mdn-Footer-logo${data.imageSrc ? '--custom' : ''}`}>
            <img
              className="mdn-Footer-logo-image"
              src={
                imageSrc ||
                'https://mondrian.claro.com.br/brands/nosvg/assinatura-claro.png'
              }
              alt={imageAlt || 'Logo da Claro'}
            />
          </div>
        </div>
      </div>
    </CustomTag>
  )
}
